module.exports = __webpack_public_path__ + "static/media/rtos.4595bee5.png";